import {
    Button,
    FormControl,
    Grid,
    InputBase,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
    makeStyles,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { http } from '../../network'
import { toast } from 'react-toastify'
import { grey } from '@material-ui/core/colors'

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: '#fff',
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    floatingLabelFocusStyle: {
        color: grey[600],
    },
    selectStyle: {
        border: '1px solid',
        borderColor: grey[400],
        borderRadius: 5,
        padding: 8,
    },
}))

const UserModal = ({ open, onModalClose, userDetails, getAllUsers }) => {
    const styles = useStyles()
    const [details, setDetails] = useState({})
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        setDetails(userDetails)
    }, [userDetails])

    const onChange = (value, field) => {
        setDetails((prev) => ({
            ...prev,
            [field]: value,
        }))
    }

    const onClose = () => {
        setDetails({})
        onModalClose()
    }

    const disabledOnNoValues = () => {
        if ((!details?.first_name || !details?.last_name || !details?.role)) {
            return true
        }
    }

    const saveOrUpdate = async () => {
        try {
            setDisabled(true)
            const body = {
                first_name: details.first_name,
                last_name: details.last_name,
                role: details.role,
                ...(details?.email && { email: details.email }),
                ...(details?.password && { password: details.password }),
            }

            const method = details?._id ? 'put' : 'post'
            const endPoint = details?._id ? `/user/${details?._id}` : '/register'
            await http[method](endPoint, body)
            getAllUsers()
            toast.success(details?._id ? 'User Updated' : 'User created')
            onClose()
        } catch (error) {
            setDisabled(false)
            toast.error('Could not update user')
            onClose()
        }
    }

    return (
        <div>
            <Modal open={open} onClose={onClose}>
                <Grid className={styles.paper} container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            required
                            label='First Name'
                            variant='outlined'
                            value={details?.first_name || ''}
                            onChange={(e) => onChange(e.target.value, 'first_name')}
                            InputLabelProps={{
                                className: styles.floatingLabelFocusStyle,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            required
                            label='Last Name'
                            variant='outlined'
                            value={details?.last_name || ''}
                            onChange={(e) => onChange(e.target.value, 'last_name')}
                            InputLabelProps={{
                                className: styles.floatingLabelFocusStyle,
                            }}
                        />
                    </Grid>
                    {!details?._id ? (
                        <>
                            {' '}
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete='off'
                                    fullWidth
                                    required
                                    label='Email'
                                    type='email'
                                    variant='outlined'
                                    value={details?.email || ''}
                                    onChange={(e) => onChange(e.target.value, 'email')}
                                    InputLabelProps={{
                                        className: styles.floatingLabelFocusStyle,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete='off'
                                    fullWidth
                                    required
                                    label='Password'
                                    variant='outlined'
                                    value={details?.password || ''}
                                    onChange={(e) => onChange(e.target.value, 'password')}
                                    InputLabelProps={{
                                        className: styles.floatingLabelFocusStyle,
                                    }}
                                />
                            </Grid>{' '}
                        </>
                    ) : null}
                    <Grid item xs={12}>
                        <FormControl fullWidth variant='filled'>
                            <Select
                                labelId='role'
                                id='role-io'
                                value={details.role || ''}
                                onChange={(e) => onChange(e.target.value, 'role')}
                                input={<InputBase />}
                                fullWidth
                                label='Role'
                                className={styles.selectStyle}
                            >
                                <MenuItem value=''>
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={'admin'}>Admin</MenuItem>
                                <MenuItem value={'user'}>User</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} style={{ gap: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button disabled={disabled} onClick={onClose} variant='outlined'>
                            Cancel
                        </Button>
                        <Button
                            disabled={disabledOnNoValues() || disabled}
                            onClick={saveOrUpdate}
                            variant='contained'
                            color='danger'
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    )
}

export default UserModal
